import Utils from '../../Utils';

export default class MainMinHeight {

    static initializeEvents() {
        this.applyMinHeight();
        addEventListener('resize', Utils.throttle(this.applyMinHeight.bind(this), 20));
    }

    static applyMinHeight() {
        const main = document.querySelector('main[role="main"]');
        const footer = document.querySelector('footer.footer');

        if (main && footer && (footer.offsetTop + footer.clientHeight) < window.innerHeight) {
            main.style.minHeight = (window.innerHeight - 580) + 'px';
            this.hideScrollTopButton();
        } else if (main && footer) {
            main.style.minHeight = '';
        }
    }

    static hideScrollTopButton() {
        const scrollButton = document.querySelector('.scroll-top');
        if (scrollButton) {
            scrollButton.classList.add('hidden');
        }
    }

}